export function isNavigationAbort(reason: unknown): boolean {
    return typeof reason === "object" && reason !== null &&
        "name" in reason && reason.name === "AbortError";
}
